{
	"assure": "Assure",
	"reject": "Reject",
	"requestInformation": "Request information"
}
